import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    drivers: [{id: new Date().getTime()}]
  },
  getters: {
    drivers(state) {
        return state.drivers;
    }
  },
  mutations: {
    addDriver (state, driver) {
        state.drivers.push(driver);
    },
    removeDriver (state, index) {
        state.drivers.splice(index, 1);
    }
  },
  actions: {

  }
})

export default store;